export default __webpack_public_path__ + "static/media/auto-doors.dc413bc1.svg";